export default {
    init() {
    },
    finalize() {
    },
};
